import { FC } from 'react'
import styled from 'styled-components'
import Modal from '../../../shared/modal/Modal'
import ModalTitle from '../../../shared/modal/ModalTitle'
import ModalContent from '../../../shared/modal/ModalContent'
import Progress from '../../../shared/Progress'

const DescriptionStyled = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey.dark};
  font-size: 14px;
  line-height: 20px;
`

type TCsvImportModalProps = {
  open: boolean
  progress: number
}

const CsvImportModal: FC<TCsvImportModalProps> = ({ open, progress }) => (
  <Modal
    open={open}
    disableEscapeKeyDown
  >
    <ModalTitle>Import in progress</ModalTitle>
    <ModalContent sx={{ display: 'grid', gridRowGap: '16px' }}>
      <DescriptionStyled>
        This may take some time — please do not refresh the page.
      </DescriptionStyled>
      <Progress value={progress} />
    </ModalContent>
  </Modal>
)

export default CsvImportModal
